import { makeStyles } from '@map/theme';
import { Paper, Typography } from '@mui/material';
import { ReactNode } from 'react';
import BackgroundStyle from '../../BackgroundStyle';

export const publicPageWidth = 120;

const useStyles = makeStyles(({ borderRadius, breakpoints, spacing, palette, sizing, shadow }) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    padding: spacing(0, 6),
    margin: '0 auto',
    flexDirection: 'column',
    '& > *': {
      width: '100%',
      maxWidth: sizing(publicPageWidth),
    },
  },
  title: {
    marginBottom: spacing(4),
    [breakpoints.down('md')]: {
      color: palette.common.white,
    },
  },
  formBox: {
    padding: spacing(6),
    borderRadius: borderRadius('l'),
    boxShadow: shadow('s'),
    [breakpoints.down('md')]: {
      boxShadow: shadow('s', palette.primary[900]),
    },
  },
  footer: {
    padding: spacing(7, 0),
    color: palette.neutrals[800],
    [breakpoints.down('md')]: {
      color: palette.common.white,
    },
  },
}));

type Props = {
  className?: string;
  innerClassName?: string;
  title?: ReactNode;
  children: any;
  footer?: ReactNode;
};

const PublicPage: FC<Props> = ({ className, innerClassName, title, children, footer }) => {
  const { classes, cx } = useStyles();

  return (
    <div className={cx(classes.root, className)}>
      <BackgroundStyle />
      <Typography variant="h5" align="center" className={classes.title}>
        {title}&nbsp;
      </Typography>
      <Paper elevation={0} className={cx(classes.formBox, innerClassName)}>
        {children}
      </Paper>
      {footer && <div className={classes.footer}>{footer}</div>}
    </div>
  );
};

export default PublicPage;
